import { render, staticRenderFns } from "./RiwayatUsers.vue?vue&type=template&id=2d334232"
import script from "./RiwayatUsers.vue?vue&type=script&lang=js"
export * from "./RiwayatUsers.vue?vue&type=script&lang=js"
import style0 from "./RiwayatUsers.vue?vue&type=style&index=0&id=2d334232&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports